<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            v-if="linkExists(0)"
            :link="links[0]"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">
            <p>Bei der Umnutzung der Zacherlfabrik war der sensible Umgang mit der unter Denkmalschutz stehenden Bausubstanz oberstes Entwurfsgebot. Das Gebäude und die geplante Nutzung sollten voneinander profitieren. Auf diesen Gedanken aufbauend fiel die Entscheidung zugunsten eines Ergotherapeutischen Zentrums. Bei der Umsetzung des Entwurfs sollten verschiedene Architekturelemente neu interpretiert werden, um einen direkten Bezug zum äußeren Erscheinungsbild der Zacherlfabrik zu schaffen. In den freien, nahezu barrierefreien Grundriss der Produktion sind die nutzungsneutralen Boxen für die Therapie eingestellt. Ein wesentlicher Schwerpunkt der Arbeit liegt in der Schadens-analyse der historischen Fassadenfliesen und ihrer exemplarischen Rekonstruktion der historischen Keramiken mit ihren Ornamenten und farbigen Glasuren. </p>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(1)"
                :link="links[1]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(3)"
            :link="links[3]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(4)"
                :link="links[4]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(5)"
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(6)"
            :link="links[6]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(7)"
                :link="links[7]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(8)"
                :link="links[8]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <span class="mt-5 w-full text-left">
            <p class="font-semibold">Entwurf / Konzept</p>
            <p>Markus Holzbach</p>
        </span>

    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/pc/Dahlberg-10.jpg' ),
                require( '@/assets/img/pc/Dahlberg-11.jpg' ),
                require( '@/assets/img/pc/Dahlberg-12.jpg' ),
                require( '@/assets/img/pc/Dahlberg-18.jpg' ),
                require( '@/assets/img/pc/Dahlberg-22.jpg' ),
                require( '@/assets/img/pc/Dahlberg-23.jpg' ),
                require( '@/assets/img/pc/Dahlberg-25.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 9 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 9 );
            }
        }
    }
};
</script>